import React from "react";
import ComboScroller from "./ComboScroller";

const ComboHorizontalScroller = ({
                                     combos,
                                     loadMore,
                                     hasMore,
                                     loading
                                 })=>{


    return (

        <ComboScroller
            combos={combos}
            loadMore={loadMore}
            hasMore={hasMore}
            loading={loading}
        />

    )

}

export default ComboHorizontalScroller;